// extracted by mini-css-extract-plugin
export var text = "_ak-0";